// extracted by mini-css-extract-plugin
export var blue = "_1f-h";
export var brand = "_1f-d";
export var darkGrey = "_1f-g";
export var disabled = "_1f-6";
export var disabledSubtle = "_1f-7";
export var error = "_1f-8";
export var green = "_1f-i";
export var grey = "_1f-f";
export var icon = "_1f-0";
export var inherit = "_1f-c";
export var lightGrey = "_1f-e";
export var orange = "_1f-k";
export var pink = "_1f-m";
export var primary = "_1f-1";
export var purple = "_1f-n";
export var quaternary = "_1f-4";
export var quinary = "_1f-5";
export var red = "_1f-l";
export var secondary = "_1f-2";
export var success = "_1f-b";
export var tertiary = "_1f-3";
export var warning = "_1f-9";
export var warningSecondary = "_1f-a";
export var white = "_1f-o";
export var yellow = "_1f-j";